import type { MenuItem } from '@smg-real-estate/domus';

export type TrackingParameterValue = string | number | boolean | undefined;

export interface TrackingData {
  eventAction: string;
  eventLabel: string;
  contentLanguage?: string;
}

export enum GTMEvent {
  FOOTER_INTERACTION = 'footer_interaction',
  HEADER_INTERACTION = 'header_interaction',
}

export enum EventCategory {
  FOOTER_INTERACTION = 'footer_interaction',
  HEADER_INTERACTION = 'header_interaction',
}

export enum EventLabel {
  SIDEBAR = 'sidebar',
  TAB_NAVIGATION = 'tab_navigation',
}

export enum InteractionGoal {
  OPEN_MY_ACCOUNT = 'open_my_account',
}

export function trackClickHandler(data: TrackingData): void {
  const dataObj = {
    event: GTMEvent.FOOTER_INTERACTION,
    h_event_category_006: EventCategory.FOOTER_INTERACTION,
    h_event_action_007: data.eventAction,
    h_event_label_008: data.eventLabel,
  };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataObj);
}

export function trackHeaderClickHandler(data: TrackingData): void {
  const dataObj: Record<string, TrackingParameterValue> = {
    event: GTMEvent.HEADER_INTERACTION,
    h_event_category_006: EventCategory.HEADER_INTERACTION,
    h_event_action_007: data.eventAction,
    h_event_label_008: data.eventLabel,
  };

  if (data?.contentLanguage) {
    dataObj['h_content_language_116'] = data.contentLanguage;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataObj);
}

const hasTrackingLabel = (menuItem: MenuItem): menuItem is MenuItem & { trackingLabel: string } => {
  return 'trackingLabel' in menuItem && typeof menuItem.trackingLabel === 'string';
};

const getTrackingLabel = (menuItem: MenuItem): string => {
  if (hasTrackingLabel(menuItem)) {
    return menuItem.trackingLabel;
  }
  return InteractionGoal.OPEN_MY_ACCOUNT;
};

export function handleNavTracking(
  menuItem: MenuItem,
  _event: Event,
  isMobile = false,
  locale?: string,
) {
  const eventLabel: string = isMobile ? EventLabel.SIDEBAR : EventLabel.TAB_NAVIGATION;
  trackHeaderClickHandler({
    eventAction: getTrackingLabel(menuItem),
    eventLabel,
    contentLanguage: locale,
  });
}
